const STATIC_DATA = {
  otherObj: {
    areaId: "2703",
    areaIdd: "",
    areaName: "全国",
    areaOther: [
      { areaid: 1, name: "安徽省" },
      { areaid: 2, name: "北京市" },
      { areaid: 3, name: "福建省" },
      { areaid: 4, name: "甘肃省" },
      { areaid: 5, name: "广东省" },
      { areaid: 6, name: "广西省" },
      { areaid: 7, name: "贵州省" },
      { areaid: 8, name: "海南省" },
      { areaid: 9, name: "河北省" },
      { areaid: 10, name: "河南省" },
      { areaid: 11, name: "黑龙江省"},
      { areaid: 12, name: "湖北省" },
      { areaid: 13, name: "湖南省" },
      { areaid: 14, name: "吉林省" },
      { areaid: 15, name: "江苏省" },
      { areaid: 16, name: "江西省" },
      { areaid: 17, name: "辽宁省" },
      { areaid: 18, name: "内蒙古" },
      { areaid: 19, name: "宁夏省" },
      { areaid: 20, name: "青海省" },
      { areaid: 21, name: "山东省" },
      { areaid: 22, name: "山西省" },
      { areaid: 23, name: "陕西省" },
      { areaid: 24, name: "上海市" },
      { areaid: 25, name: "四川省" },
      { areaid: 26, name: "天津市" },
      { areaid: 27, name: "西藏" },
      { areaid: 28, name: "新疆" },
      { areaid: 29, name: "云南省" },
      { areaid: 30, name: "浙江省" },
      { areaid: 31, name: "重庆市" },
    ],
    friendLinks: [],
    guessYouLike: [
      { name: "住房城乡建设厅", id: 411 },
      { name: "国土资源厅", id: 412 },
      { name: "商务厅", id: 413 },
      { name: "司法厅", id: 414 },
      { name: "科技厅", id: 415 },
      { name: "农业厅", id: 416 },
      { name: "住房和城乡建设厅", id: 417 },
      { name: "交通运输厅", id: 418 },
      { name: "教育厅", id: 419 },
      { name: "财政厅", id: 420 },
      { name: "人社厅", id: 421 },
      { name: "住建厅", id: 422 },
      { name: "人力资源和社会保障厅", id: 423 },
      { name: "公安厅", id: 424 },
      { name: "人民政府办公厅", id: 425 },
      { name: "水利厅", id: 426 },
      { name: "卫生厅", id: 427 },
      { name: "应急管理厅", id: 428 },
      { name: "政协办公厅", id: 429 },
      { name: "自然资源厅", id: 430 },
    ],
    keyword: "综测仪",
    nationalGuessYouLike: [
      { name: "通讯", id: 20 },
      { name: "苯甲基硅油Ⅴ", id: 20212 },
      { name: "立式管道化工泵", id: 37299 },
      { name: "兄弟一体机碳粉", id: 65725 },
      { name: "手机音箱礼品", id: 90443 },
      { name: "惠普家用电脑", id: 108061 },
      { name: "锦鲤鱼", id: 124141 },
      { name: "独家规格", id: 149802 },
      { name: "盈科电器", id: 219965 },
      { name: "塑料绕线器", id: 228965 },
      { name: "发酵箱单门", id: 231778 },
      { name: "电子张力器", id: 236415 },
      { name: "牛津纺坯布", id: 248735 },
      { name: "特白碳酸钙", id: 256586 },
      { name: "再生料求购", id: 262983 },
      { name: "量具刃具刀具", id: 265404 },
      { name: "灯座塑件", id: 266568 },
      { name: "涤纶色织", id: 319274 },
      { name: "比利时巧克力原料", id: 323961 },
      { name: "质检机构", id: 356233 },
    ],
    nowUrl: "/gjxx/227850/0003/",
    purchasingAgency: [
      { name: "东莞市宏霖五金橡胶制有限公司", id: 38026908 },
      { name: "青岛锐城智能设备有限公司", id: 38026907 },
      { name: "青岛德音化工有限公司", id: 38026906 },
      { name: "青岛乾泓盛机械有限公司", id: 38026905 },
      { name: "青岛绿荣园艺景观有限公司", id: 38026904 },
      { name: "青岛金庄天缘国际贸易有限公司", id: 38026903 },
      { name: "青岛博鑫七彩贝壳新型建材有限公司", id: 38026902 },
      { name: "青岛鸿鑫宇有限公司", id: 38026901 },
      { name: "青岛万仕和有限公司", id: 38026900 },
      { name: "青岛好富得包装有限公司", id: 38026899 },
    ],
    ssx: "sheng",
    title: "福建综测仪招标采购",
    typesId: "4",
    typesName: "",
    wId: 227850,
  },
  listObj: {
    areaName: "福建",
    showType:0,
    bodyData: [
      {
        keyworDescribe: "关键描述:",
        progstr:'中标结果',
        areaid: 1345,
        areaName: "苏州市",
        contentid: 404677637,
        typeid: 46,
        inputtime: "2024-01-05",
        title:
          "高创（苏州）电子有限公司年产新型显示器500万台、可兼容数字电视300万台生产技术改造项目评标结果公示公告(1)",
        progid: 3,
        url: "https://www.qianlima.com/zb/detail/20240105_398905407.html",
        content:
          "...产技术改造项目 招标项目编号：4197-214BOEGC0001/12 招标范围：5G无线<a style='color:red;'>综测仪</a> 招标机构：中电商务（北京）有限公司 招标人：高创（苏州）电子有限公司 开标时间：2024-01-03 10:00 公示开始时间：2024-01-05 15:45 评标公示截止时间：2024-01-09 23:59 中标候选人名单： 候选人排名 投标商名称 制造商...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        progstr:'中标结果',
        areaid: 917,
        areaName: "郑州市",
        contentid: 404679433,
        typeid: 51,
        inputtime: "2024-01-05",
        title: "河南省计量测试科学研究院宽带无线通信综测仪（WLAN蓝牙测试模块）功能升级改造采购项目成交公告",
        progid: 3,
        url: "https://www.qianlima.com/zb/detail/20240105_398855266.html",
        content:
          "河南省计量测试科学研究院宽带无线通信<a style='color:red;'>综测仪</a>（WLAN蓝牙测试模块）功能升级改造采购项目成交公告 发布日期：2024年01月05日 附件下载:河南省计量测试科学研究院宽带无线通信<a style='color:red;'>综测仪</a>（WLAN蓝牙测试模块）功能升级改造采购项目成交公告.pdf( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        progstr:'中标结果',
        areaid: 917,
        areaName: "郑州市",
        contentid: 398119756,
        typeid: 51,
        inputtime: "2024-01-01",
        title: "河南省计量测试科学研究院宽带无线通信综测仪（WLAN蓝牙测试模块）功能升级改造采购项目单一来源采购公告",
        progid: 3,
        url: "https://www.qianlima.com/zb/detail/20240101_398119756.html",
        content:
          "河南省计量测试科学研究院宽带无线通信<a style='color:red;'>综测仪</a>（WLAN蓝牙测试模块）功能升级改造采购项目单一来源采购公告 发布日期：2024年01月01日 附件下载:河南省计量测试科学研究院宽带无线通信<a style='color:red;'>综测仪</a>（WLAN蓝牙测试模块）功能升级改造采购项目单一来源采购公告.pdf( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        progstr:'中标结果',
        areaid: 917,
        areaName: "郑州市",
        contentid: 396497855,
        typeid: 51,
        inputtime: "2023-12-22",
        title: "河南省计量测试科学研究院宽带无线通信综测仪（WLAN蓝牙测试模块）功能升级改造采购项目单一来源采购公示",
        progid: 3,
        url: "https://www.qianlima.com/zb/detail/20231222_396497855.html",
        content:
          "河南省计量测试科学研究院宽带无线通信<a style='color:red;'>综测仪</a>（WLAN蓝牙测试模块）功能升级改造采购项目单一来源采购公示 发布日期：2023年12月22日 附件下载:河南省计量测试科学研究院宽带无线通信<a style='color:red;'>综测仪</a>（WLAN蓝牙测试模块）功能升级改造采购项目单一来源采购公示.pdf( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        progstr:'招标',
        areaid: 1822,
        areaName: "青岛市",
        contentid: 396480051,
        typeid: 67,
        inputtime: "2023-12-22",
        title: "海尔科技 进口综测仪--竞价采购公告",
        progid: 0,
        url: "https://www.qianlima.com/zb/detail/20231222_396480051.html",
        content:
          "...海尔科技 进口<a style='color:red;'>综测仪</a>--竞价采购公告 发布日期：2023-12-22 采购类别：(SS20230028)进口<a style='color:red;'>综测仪</a> 采购组织：青岛海尔国际贸易有限公司 地区： 采购部门：青岛海尔国际贸易有限公司 招标地址：海尔招标网(http://www.haierbid.com) 一、项目内容 项目标号：JJ-2312-16260 项目标名：海尔科技 进口<a style='color:red;'>综测仪</a>--竞价...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 1176,
        progstr:'中标结果',
        areaName: "衡阳县",
        contentid: 393048434,
        typeid: 67,
        inputtime: "2023-12-09",
        title: "B事业群IDX（深圳衡阳）新购无线综测仪需求1208",
        progid: 0,
        url: "https://www.qianlima.com/zb/detail/20231209_393048434.html",
        content:
          "B事業群 IDX（深圳 衡陽）新購無線綜測儀需求1208 8-- 标案信息 标案号: J20231208016 地区: 衡阳 招标公司: 发布时间: 2023-12-08 09:44 数量: 6.00臺 是否含税: 招标方式: 招标类别: 设备采购 保证金: 无 标书文件: 無線綜合測試儀需求評估調查表1122 (2).xlsx 招标附件: 竞标规则 竞价类...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 858,
        areaName: "南阳市",
        contentid: 391121960,
        typeid: 67,
        inputtime: "2023-12-01",
        title: "南航南阳基地无线电综测仪成交结果公示",
        progid: 3,
        url: "https://www.qianlima.com/zb/detail/20231201_391121960.html",
        content:
          "...南航南阳基地无线电<a style='color:red;'>综测仪</a>成交结果公示 发布时间： 2023-12-01 20:47:48 南航南阳基地无线电<a style='color:red;'>综测仪</a>成交结果公示 项目名称：无线电<a style='color:red;'>综测仪</a> 项目编号：CZ2023010648 采购人：中国南方航空股份有限公司南阳基地 采购方式：公开竞价 评审时间：2023年11月28日 经评审委员会评审，推荐成交候选人如下： 序号 成交候选供应商 成交项目 成交...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 126,
        areaName: "北京",
        contentid: 390325617,
        typeid: 67,
        inputtime: "2023-11-29",
        title: "中国信息通信研究院电磁辐射测试能力2023年扩展-综测仪升级成交公告",
        progid: 3,
        url: "https://www.qianlima.com/zb/detail/20231129_390325617.html",
        content:
          "...中国信息通信研究院电磁辐射测试能力2023年扩展-<a style='color:red;'>综测仪</a>升级成交公告 一、项目编号：0701-234113027R62（招标文件编号：0701-234113027R62） 二、项目名称：中国信息通信研究院电磁辐射测试能力2023年扩展-<a style='color:red;'>综测仪</a>升级 三、中标（成交）信息 供应商名称：汇荣（北京）科技有限公司 供应商地址：北京市昌平区回龙观镇立业路6号院2号楼2...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 1822,
        areaName: "青岛市",
        contentid: 389315565,
        typeid: 67,
        inputtime: "2023-11-24",
        title: "海尔科技 进口综测仪--技术标＆商务标采购公告",
        progid: 0,
        url: "https://www.qianlima.com/zb/detail/20231124_389315565.html",
        content:
          "...海尔科技 进口<a style='color:red;'>综测仪</a>--技术标＆商务标采购公告 发布日期：2023-11-24 采购类别：(SS20230028)进口<a style='color:red;'>综测仪</a> 采购组织：青岛海尔国际贸易有限公司 地区： 采购部门：青岛海尔国际贸易有限公司 招标地址：海尔招标网(http://www.haierbid.com) 一、项目内容 项目标号：ZB-2311-15044 项目标名：海尔科技 进口<a style='color:red;'>综测仪</a>...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 1945,
        areaName: "太原市",
        contentid: 389214029,
        typeid: 67,
        inputtime: "2023-11-24",
        title: "高频电子信号模拟与图像机器视觉系统成交公告",
        progid: 3,
        url: "https://www.qianlima.com/zb/detail/20231124_389214029.html",
        content:
          "...生器 鼎阳SSG3032X-IQE 深圳市鼎阳科技股份有限公司 3 47900.00 4 <a style='color:red;'>综测仪</a> 鼎阳SVA1032X 深圳市鼎阳科技股份有限公司 1 36000.00...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 390,
        areaName: "深圳市",
        contentid: 388701894,
        typeid: 67,
        inputtime: "2023-11-23",
        title: "采购CMW100产线综测仪",
        progid: 1,
        url: "https://www.qianlima.com/zb/detail/20231123_388701894.html",
        content:
          "通讯检测仪器广东 深圳 发布时间：2023-11-21 采购要求/询价意向 询价物品 CMW100产线<a style='color:red;'>综测仪</a> 采购总量面议 目标单价面议( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 1945,
        areaName: "太原市",
        contentid: 387807823,
        typeid: 67,
        inputtime: "2023-11-20",
        title: "高频电子信号模拟与图像机器视觉系统谈判采购公告",
        progid: 0,
        url: "https://www.qianlima.com/zb/detail/20231120_387807823.html",
        content:
          "项目概况 高频电子信号模拟与图像机器视觉系统的潜在供应商应在山西省太原市小店区龙城大街盛锦国际（文旅大厦）A座13层获取采购文件，并于2023年11月23日9点（北京时间）前提交响应文件。 一、项目基本情况 项目编号：JDZBF-JT-HW-2023015 校内编号：ZBDXJD-20230203 项目名称：高频电子信号模拟与图像机器视觉系统 采购方式：竞争...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 858,
        areaName: "南阳市",
        contentid: 387279376,
        typeid: 67,
        inputtime: "2023-11-17",
        title: "南航南阳基地无线电综测仪采购竞价公告",
        progid: 0,
        url: "https://www.qianlima.com/zb/detail/20231117_387279376.html",
        content:
          "...南航南阳基地无线电<a style='color:red;'>综测仪</a>采购竞价公告 发布时间： 2023-11-17 08:49:07 竞价公告 中国南方航空股份有限公司南阳基地(以下简称“采购人”)现对无线电<a style='color:red;'>综测仪</a>进行公开竞价采购。 1、项目简介 1.1 项目名称：无线电<a style='color:red;'>综测仪</a>。 1.2 项目编号：CZ2023010648。 1.3 项目类别：货物类。 1.4 资金来源：企业自筹资金； 1.5 项目内...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 141,
        areaName: "福州市",
        contentid: 344220938,
        typeid: 64,
        inputtime: "2023-04-14",
        title: "福州地铁1号线2023年通号、综合监控、AFC系统设备维修项目公开询价公告",
        progid: 0,
        url: "https://www.qianlima.com/zb/detail/20230414_344220938.html",
        content:
          "...，包括1台以太网交换机主机、2台视频服务器、2台ATS服务器、1台光缆熔接机、1台无线集群<a style='color:red;'>综测仪</a>、1处张力围栏（80米）、6台控制终端、2台综合监控中央服务器、5台综合监控车站服务器、5台综合监控UPS、1台大屏幕显示单元、1台AFC中央服务器、4台AFC站级服务器。具体内容见询价文件第五章《项目需求书》。 注： 1.本项目为总价包干合同。 2.本项目服务期...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 141,
        areaName: "福州市",
        contentid: 286941046,
        typeid: 51,
        inputtime: "2022-08-15",
        title: "福州地铁1号线2022年通信设备维修项目重新询价公告",
        progid: 0,
        url: "https://www.qianlima.com/zb/detail/20220815_286941046.html",
        content:
          "...名称 项目内容 1 福州地铁1号线2022年通信设备维修项目（重新询价） 维修一台无线集群<a style='color:red;'>综测仪</a>、一台光缆熔接机及黄山主所80米电子围栏，具体内容见询价文件第三章《项目需求书》。 注： 1.本项目为固定总价合同。 2.质保期：本项目质保期为验收合格之日起12个月。 3.资格审查方式：资格后审。 4.最高限价（含税）：155700.00元 二、 报价人资格条件...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 141,
        areaName: "福州市",
        contentid: 282533306,
        typeid: 51,
        inputtime: "2022-07-18",
        title: "福州地铁1号线2022年通信设备维修项目询价公告",
        progid: 0,
        url: "https://www.qianlima.com/zb/detail/20220718_282533306.html",
        content:
          "...序号 项目名称 项目内容 1 福州地铁1号线2022年通信设备维修项目 维修一台无线集群<a style='color:red;'>综测仪</a>、一台光缆熔接机及黄山主所80米电子围栏，具体内容见询价文件第三章《项目需求书》。 注： 1.本项目为固定总价合同。2.质保期：本项目质保期为验收合格之日起12个月。3.资格审查方式：资格后审。4.最高限价（含税）：155700.00元 二、 报价人资格条件要求...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 196,
        areaName: "厦门市",
        contentid: 266211234,
        typeid: 67,
        inputtime: "2022-04-06",
        title: "厦门市产品质量监督检验院关于采购助听器抗扰度测试系统进口产品的需求公告",
        progid: 1,
        url: "https://www.qianlima.com/zb/detail/20220406_266211234.html",
        content:
          "厦门市产品质量监督检验院关于采购助听器抗扰度测试系统进口产品的需求公告 厦门市产品质量监督检验院 关于采购助听器抗扰度测试系统进口产品的需求公告 我单位拟采购以下产品，因国内供应商无法满足需求，准备申请采购进口产品，根据相关规定，现将采购需求挂网公示，具体内容如下： 一、 项目基本信息 采购单位：厦门市产品质量监督检验院 项目名称：助听器抗扰度测试系统 预算...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 196,
        areaName: "厦门市",
        contentid: 266211237,
        typeid: 67,
        inputtime: "2022-04-06",
        title: "厦门市产品质量监督检验院关于采购雷达波测试系统进口产品的需求公告",
        progid: 1,
        url: "https://www.qianlima.com/zb/detail/20220406_266211237.html",
        content:
          "厦门市产品质量监督检验院关于采购雷达波测试系统进口产品的需求公告 厦门市产品质量监督检验院 关于采购雷达波测试系统进口产品的需求公告 我单位拟采购以下产品，因国内供应商无法满足需求，准备申请采购进口产品，根据相关规定，现将采购需求挂网公示，具体内容如下： 一、 项目基本信息 采购单位：厦门市产品质量监督检验院 项目名称：雷达波测试系统 预算金额：270万元...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 141,
        areaName: "福州市",
        contentid: 242850130,
        typeid: 67,
        inputtime: "2021-10-13",
        title: "福建省承诚招标代理有限公司关于福州大学科研仪器设备采购项目公开招标公告",
        progid: 0,
        url: "https://www.qianlima.com/zb/detail/20211013_242850130.html",
        content:
          "福建省承诚招标代理有限公司关于福州大学科研仪器设备采购项目公开招标公告 2021年10月13日 15:04 公告信息： 采购项目名称 福建省承诚招标代理有限公司关于福州大学科研仪器设备采购项目 品目 货物/通用设备/仪器仪表/其他仪器仪表 采购单位 福州大学 行政区域 福建省 公告时间 2021年10月13日 15:04 获取招标文件时间 2021年10月1...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
      {
        keyworDescribe: "关键描述:",
        areaid: 141,
        areaName: "福州市",
        contentid: 241718089,
        typeid: 67,
        inputtime: "2021-09-30",
        title: "福州大学科研仪器设备采购项目预公告",
        progid: 1,
        url: "https://www.qianlima.com/zb/detail/20210930_241718089.html",
        content:
          "招标编号：[3500]CCZB[GK]2021046 1．招标文件编号：[3500]CCZB[GK]2021046 2．招标项目内容：福州大学科研仪器设备采购项目 3．采 购 单 位：福州大学 4．预公告建议函递交截止时间: 2021年10月11日17点30分止 致各潜在供应商： 关于福州大学福州大学科研仪器设备采购项目预公告【招标编号：[3500]CCZB...( <span style='color: #EA0A00'>综测仪</span> 在正文中 )",
      },
    ],
    keyword: "综测仪",
    title: "福建综测仪招标采购",
    total: 395,
  },
};
export default STATIC_DATA;
